export default "__VITE_ASSET__BDEbOx2Q__"